import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import signature from '@/components/signature'
import Tradition from '@/components/Tradition'

Vue.use(Router)

export default new Router({
  mode:'history',
  //base:'/hehe/',
  routes: [
    { path: '/',name: 'index',component: index},
    { path: '/signature',name: 'signature',component: signature},
    { path: '/Tradition',name: 'signature',component: Tradition},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js